import { Space,  Select, Button,  Table, Tooltip, Form, message, Divider, Popover, DatePicker } from 'antd';
import {  CheckOutlined, CloseOutlined,FileExcelOutlined } from '@ant-design/icons';
import { useState, useEffect, useContext } from 'react';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import Cookies from 'js-cookie';
import WebLinks from '../../api/WebLinks';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, downloadFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import moment from 'moment';
import SmartScorecard from '../jobs/SmartScorecard';
import { useLocation } from 'react-router-dom';
import { CommonContext } from '../../Context';

const { Option } = Select
const { RangePicker } = DatePicker

const AppScoreApplications = (props) => {
  //Variable declaration
  const [dataSource, setDataSource] = useState([]);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [priorityCheck,setPriorityCheck]=useState("f");
  const [rangePickerValue, setRangePickerValue] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 200,
  });
  const location = useLocation();
  const record = location.state?.record;
  const scoreValue = location.state?.scoreValue;
  const startDate = location.state?.startDate;
  const endDate = location.state?.endDate;
  const viewType = location.state?.viewType;
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  //Function on page load
  useEffect(() => {
    const date1 = startDate
      ? dayjs(startDate, constants.DateFormat2)
      : dayjs().startOf('month');

    const date2 = endDate
      ? dayjs(endDate, constants.DateFormat2)
      : dayjs().endOf('day');

    form.setFieldsValue({
      rangePicker: [date1, date2],
    });

    setRangePickerValue([
      date1.format(constants.DateFormat2),
      date2.format(constants.DateFormat2),
    ]);

    // getBuyerPrioritylist();
    fetchYourJobsApplicationLogList(
      viewType === 'supplier' ? record?.supplierId : record?.occupationId,
      scoreValue,
      date1.format(constants.DateFormat2),
      date2.format(constants.DateFormat2)
    );

    trackPageAccess(buyerId,window.location.href)

  }, []);

  //Function to get priority list
  // const getBuyerPrioritylist=async()=>{
  //   let url = WebLinks.GetBuyerPriorityFilters +buyerId;    
  //   const response = await APIUtils.apiCall('GET', url);
  //   if (!response.isCatch && response.resultObj) {
  //     let temppriorityColorCode=[];
  //     setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
  //     response?.resultObj?.data.forEach(element => {
  //       let priorityObj={
  //         value:element.priorityLevel.toString(),
  //         colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
  //         customName:element.customName,
  //       }
  //       temppriorityColorCode.push(priorityObj);
  //     });
  //   } else {
  //     message.error(response?.resultObj?.message);
  //   }
  // };
  // Table columns
  const yourJobsColumns = [
    // {
    //   title: 'Active',
    //   key: 'active',
    //   dataIndex: 'active',
    //   align: 'center',
    //   sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
    //   render: (_, record) =>
    //     record.active === true ? (
    //       <Button
    //         icon={<CheckOutlined className="text-xl text-lime-500" />}
    //         type="text"
    //         onClick={() => changeActive(record.id, record.active)}
    //       />
    //     ) : (
    //       <Button
    //         icon={<CloseOutlined className="text-xl text-lime-500" style={{ color: "red" }} />}
    //         type="text"
    //         onClick={() => changeActive(record.id, record.active)}
    //       />
    //     ),
    // },
    {
      title: 'Created On',
      dataIndex: 'createdOn',
      key: 'createdOn',
      width: '12%',
      render: (createdOn) => {
        {return<span className='whitespace-nowrap'><p>{moment(createdOn).format('YYYY-MM-D')}</p><p>{moment(createdOn).format('h:mm a')}</p></span>}
      },
      sorter: (a, b) => moment(a.createdOn).unix() - moment(b.createdOn).unix(),
  },
    // {
    //   title: 'Priority',
    //   dataIndex: 'priority',
    //   key: 'priority',
    //   sorter: (a, b) => a.priority - b.priority,
    //   align: "center",
    //   render: (text,element) => <Space>
    //       <div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(element.priority):GetPriorityLevelColors(element.priority)}></div>
		// 		</Space>
    // },
    {
      title: 'Supplier',
      dataIndex: 'supplierName',
      key: 'supplierName',
      sorter: (a, b) => (a?.supplierName || '').localeCompare(b?.supplierName || ''),
    },
    {
      title: 'GAP',
      align: 'center',
      width: '7%',
      dataIndex: 'overallScore',
      key: 'overallScore',
      sorter: (a, b) => (a?.overallScore ?? 0) - (b?.overallScore ?? 0),
      render: (value, record) => {
        if (!value) {
          return '-';
        }
        return (
          <Popover
            placement="right"
            autoAdjustOverflow
            destroyTooltipOnHide
            overlayStyle={{
              maxWidth: '90vw',
              width: '750px',
            }}
            content={
              <div
                style={{
                  maxHeight: '90vh',
                  overflowY: 'auto',
                  overflowX: 'auto',
                }}
              >
                <SmartScorecard
                  json={record?.breakdown || {}}
                  firstName={record?.firstName}
                  lastName={record?.lastName}
                />
              </div>
            }
            trigger="hover"
          >
            <span className="cursor-pointer text-blue-500">
              {value || "-"}
            </span>
          </Popover>
        );
      },
    },
    {
      title: 'Job Title',
      dataIndex: 'jobTitle',
      key: 'jobTitle',
      sorter: (a, b) => (a?.jobTitle || '').localeCompare(b?.jobTitle || ''),
    },
    // {
    //   title: 'Location',
    //   dataIndex: 'place',
    //   key: 'place',
    //   sorter: (a, b) => a.place.localeCompare(b.place),
    // },
    // {
    //   title: 'Reference',
    //   dataIndex: 'reference',
    //   key: 'reference',
    //   sorter: (a, b) => {
    //     const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
    //     const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);

    //     return referenceA - referenceB;
    //   },
    // },
    {
      title: 'Name',
      key: 'userFirstName',
      // hidden:  !(Cookies.get(constants.COOKIE_CANDIDATE_TAB) === "false" || Cookies.get(constants.COOKIE_CANDIDATE_TAB) === false || Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true),
      sorter: (a, b) => (a?.firstName || '').localeCompare(b?.firstName || ''),
      render: (_, record) => (<>
        <div className='no-wrap'>{record.firstName + " " + record.lastName}</div>
        <div className='whitespace-nowrap overflow-hidden text-ellipsis' >{record.telephone}</div>
    </>),
    },
    {
      title: 'Status',
      dataIndex: 'reportingStatus',
      key: 'reportingStatus',
      width: '15%',
      sorter: (a, b) => (a?.reportingStatus || '').localeCompare(b?.reportingStatus || ''),
    },
    // {
    //   title: 'Spend',
    //   dataIndex: 'spend',
    //   key: 'spend',
    //   sorter: (a, b) => a.spend - b.spend,
    // },
  ];

  //Fetch the app score list for the selected date range
  const fetchYourJobsApplicationLogList = async (id, score, dateFrom, dateTo) => {
    setIsLoading(true);
    let url = WebLinks.GetGAPAnalysisApplications + buyerId;
    url += "&dateFrom=" + dateFrom + "&dateTo=" + dateTo;
    if (id) {
      url += "&" + (viewType === 'supplier' ? "supplierId" : "occupationId") + "=" + id;
    }
    if (score) {
      url += "&score=" + score;
    }
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setDataSource(response.resultObj.data);
    } else {
      message.error(response.resultObj?.message);
    }
    setIsLoading(false);
  };

  //Function to change the Active button to cross or tick.
  // const changeActive = async (rowKey, previousValue) => {
  //   let tbldata = [...dataSource];
  //   let index = tbldata.findIndex((row) => row.id === rowKey);
  //   if (index > -1) {
  //     if (tbldata[index].active === true) {
  //       tbldata[index].active = false;
  //     } else {
  //       tbldata[index].active = true;
  //     }
  //     setDataSource(tbldata);
  //   }
  //   //Api call to update in DB
  //   let activePayload = null;
  //   activePayload = {
  //     active: !previousValue,
  //   }
  //   const activeResponse = await APIUtils.apiCall('PUT', WebLinks.PutActiveJob, JSON.stringify(activePayload));
  //   if (activeResponse.isCatch) {
  //     message.error(message.resultObj.message);
  //   }
  // };

  //Function runs when range picker value is changed
  const RangePickerChanged = debounce((_, dateStrings) => {
    setRangePickerValue([
      dateStrings[0],
      dateStrings[1],
    ]);
    sessionStorage.setItem(
      'appScoreFilters',
      JSON.stringify({
        rangePickerValue: dateStrings,
        viewType,
      })
    );
    let id = viewType === 'supplier' ? record?.supplierId : record?.occupationId;
    fetchYourJobsApplicationLogList(id, scoreValue, dateStrings[0], dateStrings[1]);
  }, 500);
  return (
    <div>
      <div className="flex justify-between items-center gap-1">
        <Space>
          <div className="uppercase font-bold text-xl">GAP Analysis Applications</div>
        </Space>
      </div>
      <Divider className="my-3" />
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Space wrap >
          <Form form={form} className='!w-full flex flex-wrap justify-between items-center gap-3 mb-3'>
            {/* <label className='ml-2 mr-2'></label> */}
            <Form.Item name="rangePicker" className='mb-0'>
              <RangePicker
                placeholder={['From', 'To']}
                onChange={RangePickerChanged}
                format={constants.DateFormat2}
                disabledDate={(current) =>
                  current && current > dayjs().endOf('day')
                }
              />
            </Form.Item>
            {/* <Tooltip placement='right' title="Download as Excel">
								<Button
										className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
										icon={<FileExcelOutlined />}
										onClick={()=>{downloadFile()}}
								>
									Download as Excel
								</Button>
								</Tooltip> */}
          </Form>
        </Space>
      </div>
      <div className="overflow-x-auto">
        <Table
          loading={isLoading}
          size='small'
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            onChange: (page, pageSize) => {
              setPagination({
                current: page,
                pageSize,
              });
            },
          }}
          columns={yourJobsColumns}
          dataSource={dataSource}
          footer={() => {
            if (!dataSource || dataSource.length === 0) return null;

            const start =
              (pagination.current - 1) * pagination.pageSize + 1;
            const end = Math.min(
              pagination.current * pagination.pageSize,
              dataSource.length
            );
            return `Showing ${start} to ${end} of ${dataSource.length} entries`;
          }}
        />
      </div>
    </div>
  );
};

export default AppScoreApplications;